/**
 * <ChatMessage /> — renders one conversation turn (M22).
 *
 * User turns are a right-aligned bubble; assistant turns delegate to
 * <ChatStreamingMessage /> (which handles streaming text, tool-call
 * indicators, inline results, and errors).
 */

import { ChatStreamingMessage } from "./ChatStreamingMessage";
import type { ChatTurn } from "./types";

export function ChatMessage({
  turn,
  sessionId,
  onSendMessage,
  onSaveDraft,
  onApplyConfirmation,
  onCancelConfirmation,
}: {
  turn: ChatTurn;
  sessionId?: string | null;
  onSendMessage?: (text: string) => void;
  onSaveDraft?: (draft: {
    kind: string;
    title: string;
    content: string;
  }) => void;
  onApplyConfirmation?: (confirmationId: string) => void;
  onCancelConfirmation?: (confirmationId: string) => void;
}) {
  if (turn.role === "user") {
    // rounded-2xl all round (no physical-corner tail) so the bubble
    // is correct in both LTR and RTL without per-direction CSS.
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] whitespace-pre-wrap rounded-2xl bg-brand-deep-gradient px-3 py-2 text-sm text-brand-fg">
          {turn.text}
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-start">
      <div className="max-w-[92%]">
        <ChatStreamingMessage
          turn={turn}
          sessionId={sessionId ?? null}
          onSendMessage={onSendMessage}
          onSaveDraft={onSaveDraft}
          onApplyConfirmation={onApplyConfirmation}
          onCancelConfirmation={onCancelConfirmation}
        />
      </div>
    </div>
  );
}
